import React from "react";
import { Switch, Route } from 'react-router-dom';
import CategoryManagement from "./CategoryManagement";
import CategoryEditPage from "./CategoryEditPage";

export default function CategoryManagementRouter() {
  return <Switch>
    <Route path="/categories/edit/:id?" component={CategoryEditPage} />
    <Route path="/categories" component={CategoryManagement} />
  </Switch>
}
